import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'invoices-header',
  templateUrl: './invoices-header.component.html'
})
export class InvoicesHeaderComponent implements OnInit {
	@Input() allInvoices:any;
	@Input() closedInvoices:any;
	@Input() pendingInvoices:any;
	@Input() userInfo:any;
	
  constructor() { }

  ngOnInit(): void {
  }

  activePeriod: { [key: string]: string } = {
    allInvoices: 'all-tab',
    closedInvoices: 'all-tab',
    pendingInvoices: 'all-tab'
  };

  setActivePeriod(invoiceType: string, period: string) {
    this.activePeriod[invoiceType] = period;
  }

}
